import animateScrollTo from "animated-scroll-to";
import { getElements } from "@oddcamp/js-utils/src/selector";

const onClick = (e) => {
  e.preventDefault();

  const targetID = e.currentTarget.getAttribute("href");
  let targetEl = document.body;

  if (targetID != "#") {
    targetEl = document.querySelector(targetID) || document.body;
  }

  const tabIndex = parseInt(targetEl.getAttribute("tabindex")) || null;

  animateScrollTo(targetEl, {
    speed: 300,
    minDuration: 200,
    maxDuration: 800,
    onComplete: () => {
      if (!tabIndex) targetEl.tabIndex = 0;
      targetEl.focus();
      setTimeout(() => {
        if (!tabIndex) targetEl.removeAttribute("tabindex");
        else targetEl.setAttribute("tabindex", tabIndex);
      }, 10);
      window.history.pushState("", "", targetID);
    },
  });
};

const init = () => {
  const elements = getElements(".smooth-anchor");
  if (!elements.length) return;

  elements.forEach((element) => {
    element.setAttribute("data-turbolinks", false);
    element.addEventListener("click", onClick);
  });
};

if (typeof Turbolinks !== "undefined") {
  document.addEventListener("turbolinks:load", init);
} else {
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
}
